import { useParams } from 'react-router'
import toInteger from 'lodash/toInteger'
import { useNavigateWithReturnUrl } from '@klear/ui/wizard/return-url'
import type { WizardStepComponentProps } from '@klear/ui/wizard/flow'
import { PurchaseOrderSelectOrCreate } from '@/app/purchase-order/workflow/PurchaseOrderSelectOrCreate'
import { purchaseOrderCreatePath } from '@/app/purchase-order/purchase-order-create-wizard-page'
import type { ReceivableStepCtx } from '@/app/receivable/workflow/ReceivableWizardContext'

export default function PurchaseOrderStep({ ctx }: WizardStepComponentProps<ReceivableStepCtx>) {
  const { traderId: traderIdParam } = useParams<{ traderId?: string }>()
  const traderId = toInteger(traderIdParam)
  const { navigateWithReturnUrl } = useNavigateWithReturnUrl()
  const { form, attachExistingPurchaseOrder } = ctx
  const orderId = form.orderId

  if (!orderId) {
    return <div className="text-sm text-muted-foreground">Select an order first.</div>
  }

  return (
    <PurchaseOrderSelectOrCreate
      orderId={orderId}
      defaultSelectedId={form.purchaseOrderEventId}
      onAttach={attachExistingPurchaseOrder}
      onCreateNew={() => navigateWithReturnUrl(purchaseOrderCreatePath(traderId, orderId))}
    />
  )
}
